import type { InjectionKey } from "vue";

/**
 * Contenu d'onglet affiché dans une modale (CanvasPanelDialog) plutôt que
 * dans le volet droit : pas besoin d'éviter l'aide contextuelle en bas à
 * droite, que la modale ne touche pas.
 */
export const IN_PANEL_DIALOG: InjectionKey<boolean> = Symbol("in-panel-dialog");
